@switch (status) {
  @case (ResourceStatus.InProgress) {
    <div class="loading" data-testid="resource-loading">
      <app-spinner></app-spinner>
    </div>
  }
  @case (ResourceStatus.Failure) {
    <div class="error" data-testid="resource-error">
      <app-error-message [errorMessage]="error"></app-error-message>
    </div>
  }
  @case (ResourceStatus.Success) {
    <div data-testid="resource-success">
      @if (hasData) {
        <ng-container [ngTemplateOutlet]="templateRef"></ng-container>
      } @else {
        <div data-testid="no-results" class="no-results">
          <img src="assets/img/empty-list.svg" alt="No results" />
          <div class="message">
            @if (customNoDataComponent) {
              <ng-container [ngTemplateOutlet]="customNoDataComponent"></ng-container>
            } @else {
              <span>No results found</span>
            }
          </div>
        </div>
      }
    </div>
  }
}
